import React from "react"

import HeaderWrapper from "./header_wrapper"
import NavClients from "./nav_clients"

export default function HeaderClients({ heroTitle = null, children }) {
  const heroImage = "/images/slider/Clients--Banner.jpg"
  const heroMobileImage = "/images/slider/mobile/Clients--Banner.jpg"
  const breadcrumbSecondaryItem = "Clients"
  const breadcrumbSecondaryItemUrl = "/clients/business-owner"

  return (
    <HeaderWrapper
      heroTitle={heroTitle}
      heroImage={heroImage}
      heroMobileImage={heroMobileImage}
      breadcrumbSecondaryItem={breadcrumbSecondaryItem}
      breadcrumbSecondaryItemUrl={breadcrumbSecondaryItemUrl}
      NavComponent={NavClients}
    >
      {children}
    </HeaderWrapper>
  )
}
